import { ErrorBoundary } from "@/components";
import { SocketManager } from "@/services/socketService";
import useChatStore from "@/store/chatStore";
import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import LeftSection from "./LeftSection/LeftSection";

const Chat: React.FC = () => {
  // Global state to manage all chat functionality
  const setIsConnectionReady = useChatStore(
    (state) => state.setIsConnectionReady
  );
  const setFailConnectionMessage = useChatStore(
    (state) => state.setFailConnectionMessage
  );

  // Initialize socket connection here
  useEffect(() => {
    const socketManager = SocketManager.getInstance();
    socketManager.connect();

    // If already connected, set connection ready
    if (socketManager.isConnected()) {
      setIsConnectionReady(true);
      return;
    }

    // Listen for connection event
    socketManager.onConnect(() => {
      console.log("Socket connected - Chat page");
      setIsConnectionReady(true);
    });

    // Listen for disconnect event
    socketManager.onDisconnect((reason) => {
      console.log("Socket disconnected - Chat page:", reason);
      setIsConnectionReady(false);
      // setFailConnectionMessage(reason);
    });

    // Listen for connection error event
    socketManager.onError((error) => {
      console.log("Socket connection error - Chat page:", error);
      setIsConnectionReady(false);
      setFailConnectionMessage(
        "ネットワーク接続が切れました。接続を確認して、ページを再読み込みしてください。"
      );
    });

    return () => {
      socketManager.disconnect();
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="flex -ml-4 2xl:-ml-8">
        {/* User manual content */}
        <p
          className="fixed z-20 top-[1.625rem] text-[0.625rem] text-light_secondary leading-4 -translate-y-1/2 translate-x-14 lg:translate-x-4 whitespace-pre-line hidden md:block"
          title="異動・退職等によりご担当者様が変更となる場合で、事前相談の履歴を継続してご利用される際は、引継ぎ先をご指定の上、別のユーザーへ権限を譲渡してください。"
        >
          {`異動・退職等によりご担当者様が変更となる場合で、事前相談の履歴を継続してご利用される際は、\n引継ぎ先をご指定の上、別のユーザーへ権限を譲渡してください。`}
        </p>

        {/* Left section */}
        <div
          className="w-[248px] xl:w-[280px] 2xl:w-[320px] border-r
         main-content-height overflow-y-auto shrink-0"
        >
          <LeftSection />
        </div>

        <div className="flex-1 main-content-height min-w-0">
          {/* Show chat room details here */}
          <Outlet />
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default Chat;
